export const isLoggedIn = () => {
  if((localStorage.getItem('token') !== null) && (localStorage.getItem('token') !== undefined)) {
    return true;
  } else {
    return false;
  }
}
